import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { observer } from 'mobx-react';
import { getFarmPolicyMask } from 'common/helpers/farm-helpers';

import { track } from 'core/helpers/analytics';
import { OfferPageTabs } from 'core/store/offer-store';
import { useStore } from 'core/store/store.mobx';
import useStyles from './offer-tabs.styles';

const OfferTabs = observer(() => {
  const classes = useStyles();
  const { offer: store } = useStore();

  return (
    <Tabs
      id="offer_tabs"
      value={store.currentTab}
      variant="fullWidth"
      onChange={(_, newTab) => {
        store.setCurrentTab(newTab);
        track('Staff Offer Tab Clicked', { tab: newTab });
      }}
    >
      <Tab id="people_tab" value={OfferPageTabs.PEOPLE} label="People" className={classes.tab} />
      {store.shouldShowHomeTab && (
        <Tab id="home_details_tab" value={OfferPageTabs.HOME} label="Home Details" className={classes.tab} />
      )}
      {store.shouldShowRentersTab && (
        <Tab id="renters_details_tab" value={OfferPageTabs.RENTERS} label="Renters Details" className={classes.tab} />
      )}
      {store.shouldShowCondoTab && (
        <Tab id="condo_details_tab" value={OfferPageTabs.CONDO} label="Condo Details" className={classes.tab} />
      )}
      {store.shouldShowFarmTab && (
        <Tab
          id="farm_details_tab"
          value={OfferPageTabs.FARM}
          label={getFarmPolicyMask(store.selectedOption, store.state)?.tabLabel || 'Farm Details'}
          className={classes.tab}
        />
      )}
      {store.shouldShowAutoTab && (
        <Tab id="auto_details_tab" value={OfferPageTabs.AUTO} label="Auto Details" className={classes.tab} />
      )}
      {store.shouldShowPIPTab && <Tab id="pip_tab" value={OfferPageTabs.PIP} label="PIP" className={classes.tab} />}
      <Tab id="billing_tab" value={OfferPageTabs.SETTINGS} label="Billing" className={classes.tab} />
    </Tabs>
  );
});

export default OfferTabs;
